import { Link } from 'react-router-dom';
import { SeasonalFooterControls, useSeasonArt } from '../theme/seasonal';

const COLUMNS: {
  heading: string;
  links: { label: string; to: string; external?: boolean }[];
}[] = [
  {
    heading: 'Product',
    links: [
      { label: 'Downloads', to: '/downloads' },
      { label: 'Plugins', to: '/plugins' },
      { label: 'Changelog', to: '/whats-new' },
    ],
  },
  {
    heading: 'Resources',
    links: [
      { label: 'Docs', to: 'https://docs.streamnook.app/', external: true },
      { label: 'Status', to: '/status' },
    ],
  },
  {
    heading: 'Community',
    links: [
      { label: 'Discord', to: 'https://discord.gg/2xvuF9TES7', external: true },
      { label: 'GitHub', to: 'https://github.com/StreamNook/StreamNook', external: true },
    ],
  },
];

export default function Footer() {
  const logo = useSeasonArt('logo') ?? '/streamnook-logo.png';
  return (
    <footer className="site-footer w-full border-t border-[var(--color-borderSubtle)] mt-12">
      <div className="mx-auto max-w-6xl px-6 py-10">
        <div className="grid grid-cols-2 gap-8 sm:grid-cols-4">
          <div className="col-span-2 sm:col-span-1">
            <div className="flex items-center gap-2">
              <img src={logo} alt="" className="site-logo h-6 w-6 object-contain" />
              <span className="text-sm font-medium text-textPrimary">StreamNook</span>
            </div>
            <p className="mt-2 text-xs leading-relaxed text-textMuted">
              A native Twitch client for Windows, macOS, Linux and Android. In beta on iPhone through TestFlight.
            </p>
          </div>

          {COLUMNS.map(col => (
            <div key={col.heading}>
              <h3 className="text-[12px] font-medium text-textSecondary">{col.heading}</h3>
              <ul className="mt-3 space-y-2">
                {col.links.map(link => (
                  <li key={link.label}>
                    {link.external ? (
                      <a
                        href={link.to}
                        target="_blank"
                        rel="noreferrer"
                        className="text-xs text-textMuted transition-colors hover:text-textPrimary"
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link
                        to={link.to}
                        className="text-xs text-textMuted transition-colors hover:text-textPrimary"
                      >
                        {link.label}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 border-t border-[var(--color-borderSubtle)] pt-5">
          <SeasonalFooterControls />
          <span className="text-xs text-textMuted">
            © {new Date().getFullYear()} StreamNook · by Penrose
          </span>
        </div>
      </div>
    </footer>
  );
}
